import receiptsImage from './images/2017-06_ExpensePlatform.jpg'

const project = {
  path: '/expense-and-travel-platform',
  heading: 'Expense and Travel Platform',
  date: 'June 2017',
  image: receiptsImage,
  summary: 'Digitising a manual paper-based Expense and Travel Management process using a market-leading SaaS solution.',
  content: 
    <>
      <p>
        The financial sector is notorious for arriving to technology late. Facilitating change 
        in large corporations is difficult, with workforces very set in their ways and processes 
        which have diverged from what was likely a standard practice originally.
      </p>
      <p>
        Often this is felt even more when dealing with processes outside of the direct business 
        in which these corporations are dealing. Investments are made in customer facing applications 
        (naturally) and operational processes such as facilities management and finance are left 
        as a lower priority.
      </p>
      <h2>The Challenge</h2>
      <p>
        To travel on behalf of the company required engaging in an endless exchange of emails back 
        and forth with managers, travel advisors, and finance staff to agree on the best flights, 
        hotels, and other amenities. Approvals were gathered through email chains, and the decision 
        making process was impossible to follow, track or audit.
      </p>
      <p>
        Coming back from a trip was just as painful, with anyone looking to claim back expenses 
        incurred required to wander through the intranet in search of a form which they HAD to 
        print, manually complete and staple receipts to, before then having these lost in the 
        midst of in-trays and other paperwork of approving managers.
      </p>
      <h2>The Solution</h2>
      <p>
        Something had to change. Regional managers wanted to know more about how much travel was 
        being done by staff. Global directives were filtering down to encourage more online meetings 
        to limit our impact on the environment. Expenses incurred outside of procurement processes 
        needed to be more tightly controlled to get the best from purchases being done by multiple 
        offices across the globe.
      </p>
      <p>
        A global system was decided on, and needed to be rolled out ASAP. But, global delivery teams 
        were struggling to gather all the requirements of local jurisdictions. While tax and financial 
        reporting requirements seemed reasonably consistent within European Borders, coming to Asia-Pacific 
        these teams quickly discovered that processes were more complicated.
      </p>
      <p>
        They relied on local project managers to make sense of all this. With both analysis skills 
        and project management backgrounds, we were able to better assess the requirements of our 
        jurisdiction, and distill these down to specifications for the new system.
      </p>
      <h2>The Result</h2>
      <p>
        After 6 months of requirements analysis and iterating on a test application, the local business 
        finally agreed on a configuration that would enable far easier management of travel and expenses 
        whilst still ensuring that local approval and reporting requirements were met.
      </p>
      <p>
        While we faced some resistence from those who had worked with the old processes for longer 
        than we had been in our working lives, gradually the entire company in both Australia and 
        New Zealand came around, and we became the advisors to the rollout across Asia-Pacific.
      </p>
    </>
}

export default project;
